// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cta-box_wrapper__B0vXK","cta":"cta-box_cta__OFKrn"};